// Original script exposes variables to global scope and break our JS code
// Original script:
// <script src="https://pay.google.com/gp/p/js/pay.js"></script>

(function () {

    var k, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        a != Array.prototype && a != Object.prototype && (a[b] = c.value)
    }
        , l = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this, m = function(a, b) {
        if (b) {
            var c = l;
            a = a.split(".");
            for (var d = 0; d < a.length - 1; d++) {
                var e = a[d];
                e in c || (c[e] = {});
                c = c[e]
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            })
        }
    };
    m("Object.values", function(a) {
        return a ? a : function(a) {
            var b = [], d;
            for (d in a)
                Object.prototype.hasOwnProperty.call(a, d) && b.push(a[d]);
            return b
        }
    });
    m("Object.is", function(a) {
        return a ? a : function(a, c) {
            return a === c ? 0 !== a || 1 / a === 1 / c : a !== a && c !== c
        }
    });
    m("Array.prototype.includes", function(a) {
        return a ? a : function(a, c) {
            var b = this;
            b instanceof String && (b = String(b));
            var e = b.length;
            c = c || 0;
            for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
                var f = b[c];
                if (f === a || Object.is(f, a))
                    return !0
            }
            return !1
        }
    });
    var ba = "function" == typeof Object.assign ? Object.assign : function(a, b) {
            for (var c = 1; c < arguments.length; c++) {
                var d = arguments[c];
                if (d)
                    for (var e in d)
                        Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e])
            }
            return a
        }
    ;
    m("Object.assign", function(a) {
        return a || ba
    });
    var ca = function() {
        ca = function() {}
        ;
        l.Symbol || (l.Symbol = da)
    }
        , da = function() {
        var a = 0;
        return function(b) {
            return "jscomp_symbol_" + (b || "") + a++
        }
    }()
        , fa = function() {
        ca();
        var a = l.Symbol.iterator;
        a || (a = l.Symbol.iterator = l.Symbol("iterator"));
        "function" != typeof Array.prototype[a] && aa(Array.prototype, a, {
            configurable: !0,
            writable: !0,
            value: function() {
                return ea(this)
            }
        });
        fa = function() {}
    }
        , ea = function(a) {
        var b = 0;
        return ha(function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            }
        })
    }
        , ha = function(a) {
        fa();
        a = {
            next: a
        };
        a[l.Symbol.iterator] = function() {
            return this
        }
        ;
        return a
    }
        , ia = function(a) {
        fa();
        var b = a[Symbol.iterator];
        return b ? b.call(a) : ea(a)
    };
    m("Promise", function(a) {
        function b() {
            this.v = null
        }
        function c(a) {
            return a instanceof e ? a : new e(function(b) {
                    b(a)
                }
            )
        }
        if (a)
            return a;
        b.prototype.Fa = function(a) {
            null == this.v && (this.v = [],
                this.eb());
            this.v.push(a)
        }
        ;
        b.prototype.eb = function() {
            var a = this;
            this.Ga(function() {
                a.kb()
            })
        }
        ;
        var d = l.setTimeout;
        b.prototype.Ga = function(a) {
            d(a, 0)
        }
        ;
        b.prototype.kb = function() {
            for (; this.v && this.v.length; ) {
                var a = this.v;
                this.v = [];
                for (var b = 0; b < a.length; ++b) {
                    var c = a[b];
                    a[b] = null;
                    try {
                        c()
                    } catch (ka) {
                        this.fb(ka)
                    }
                }
            }
            this.v = null
        }
        ;
        b.prototype.fb = function(a) {
            this.Ga(function() {
                throw a;
            })
        }
        ;
        var e = function(a) {
            this.V = 0;
            this.L = void 0;
            this.J = [];
            var b = this.ra();
            try {
                a(b.resolve, b.reject)
            } catch (H) {
                b.reject(H)
            }
        };
        e.prototype.ra = function() {
            function a(a) {
                return function(d) {
                    c || (c = !0,
                        a.call(b, d))
                }
            }
            var b = this
                , c = !1;
            return {
                resolve: a(this.tb),
                reject: a(this.xa)
            }
        }
        ;
        e.prototype.tb = function(a) {
            if (a === this)
                this.xa(new TypeError("A Promise cannot resolve to itself"));
            else if (a instanceof e)
                this.ub(a);
            else {
                a: switch (typeof a) {
                    case "object":
                        var b = null != a;
                        break a;
                    case "function":
                        b = !0;
                        break a;
                    default:
                        b = !1
                }
                b ? this.sb(a) : this.Ma(a)
            }
        }
        ;
        e.prototype.sb = function(a) {
            var b = void 0;
            try {
                b = a.then
            } catch (H) {
                this.xa(H);
                return
            }
            "function" == typeof b ? this.vb(b, a) : this.Ma(a)
        }
        ;
        e.prototype.xa = function(a) {
            this.Xa(2, a)
        }
        ;
        e.prototype.Ma = function(a) {
            this.Xa(1, a)
        }
        ;
        e.prototype.Xa = function(a, b) {
            if (0 != this.V)
                throw Error("Cannot settle(" + a + ", " + b + "): Promise already settled in state" + this.V);
            this.V = a;
            this.L = b;
            this.lb()
        }
        ;
        e.prototype.lb = function() {
            if (null != this.J) {
                for (var a = 0; a < this.J.length; ++a)
                    f.Fa(this.J[a]);
                this.J = null
            }
        }
        ;
        var f = new b;
        e.prototype.ub = function(a) {
            var b = this.ra();
            a.ba(b.resolve, b.reject)
        }
        ;
        e.prototype.vb = function(a, b) {
            var c = this.ra();
            try {
                a.call(b, c.resolve, c.reject)
            } catch (ka) {
                c.reject(ka)
            }
        }
        ;
        e.prototype.then = function(a, b) {
            function c(a, b) {
                return "function" == typeof a ? function(b) {
                        try {
                            d(a(b))
                        } catch (cc) {
                            f(cc)
                        }
                    }
                    : b
            }
            var d, f, g = new e(function(a, b) {
                    d = a;
                    f = b
                }
            );
            this.ba(c(a, d), c(b, f));
            return g
        }
        ;
        e.prototype["catch"] = function(a) {
            return this.then(void 0, a)
        }
        ;
        e.prototype.ba = function(a, b) {
            function c() {
                switch (d.V) {
                    case 1:
                        a(d.L);
                        break;
                    case 2:
                        b(d.L);
                        break;
                    default:
                        throw Error("Unexpected state: " + d.V);
                }
            }
            var d = this;
            null == this.J ? f.Fa(c) : this.J.push(c)
        }
        ;
        e.resolve = c;
        e.reject = function(a) {
            return new e(function(b, c) {
                    c(a)
                }
            )
        }
        ;
        e.race = function(a) {
            return new e(function(b, d) {
                    for (var e = ia(a), f = e.next(); !f.done; f = e.next())
                        c(f.value).ba(b, d)
                }
            )
        }
        ;
        e.all = function(a) {
            var b = ia(a)
                , d = b.next();
            return d.done ? c([]) : new e(function(a, e) {
                    function f(b) {
                        return function(c) {
                            g[b] = c;
                            h--;
                            0 == h && a(g)
                        }
                    }
                    var g = []
                        , h = 0;
                    do
                        g.push(void 0),
                            h++,
                            c(d.value).ba(f(g.length - 1), e),
                            d = b.next();
                    while (!d.done)
                }
            )
        }
        ;
        return e
    });
    m("String.prototype.endsWith", function(a) {
        return a ? a : function(a, c) {
            if (null == this)
                throw new TypeError("The 'this' value for String.prototype.endsWith must not be null or undefined");
            if (a instanceof RegExp)
                throw new TypeError("First argument to String.prototype.endsWith must not be a regular expression");
            var b = this + "";
            a += "";
            void 0 === c && (c = b.length);
            c = Math.max(0, Math.min(c | 0, b.length));
            for (var e = a.length; 0 < e && 0 < c; )
                if (b[--c] != a[--e])
                    return !1;
            return 0 >= e
        }
    });
    var n = this
        , p = function(a) {
        return "string" == typeof a
    }
        , ja = function(a, b) {
        a = a.split(".");
        var c = window || n;
        a[0]in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
        for (var d; a.length && (d = a.shift()); )
            a.length || void 0 === b ? c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {} : c[d] = b
    }
        , la = function() {}
        , q = function(a) {
        var b = typeof a;
        if ("object" == b)
            if (a) {
                if (a instanceof Array)
                    return "array";
                if (a instanceof Object)
                    return b;
                var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c)
                    return "object";
                if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice"))
                    return "array";
                if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call"))
                    return "function"
            } else
                return "null";
        else if ("function" == b && "undefined" == typeof a.call)
            return "object";
        return b
    }
        , r = function(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b
    }
        , ma = function(a, b, c) {
        return a.call.apply(a.bind, arguments)
    }
        , na = function(a, b, c) {
        if (!a)
            throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c)
            }
        }
        return function() {
            return a.apply(b, arguments)
        }
    }
        , t = function(a, b, c) {
        t = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ma : na;
        return t.apply(null, arguments)
    }
        , u = Date.now || function() {
        return +new Date
    }
        , v = function(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.pa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Nb = function(a, c, f) {
            for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++)
                d[e - 2] = arguments[e];
            return b.prototype[c].apply(a, d)
        }
    };
    var oa = {
        Gb: "PRODUCTION",
        Ib: "TEST",
        Hb: "SANDBOX"
    }
        , pa = {
        Ab: "CARD",
        Jb: "TOKENIZED_CARD"
    }
        , qa = {
        Cb: "ESTIMATED",
        Db: "FINAL",
        Fb: "NOT_CURRENTLY_KNOWN"
    }
        , ra = {
        SHORT: "short",
        Eb: "long"
    }
        , sa = {
        Bb: "default",
        zb: "black",
        Kb: "white"
    }
        , ta = {
        en: 152,
        bg: 163,
        cs: 192,
        de: 183,
        es: 183,
        fr: 183,
        hr: 157,
        id: 186,
        ja: 148,
        ko: 137,
        ms: 186,
        nl: 167,
        pl: 182,
        pt: 193,
        ru: 206,
        sk: 157,
        sl: 211,
        sr: 146,
        tr: 161,
        uk: 207,
        zh: 156
    };
    var ua = function(a) {
        var b = document.createElement("style");
        b.type = "text/css";
        b.textContent = a;
        document.head.appendChild(b)
    };
    var va = !1;
    function wa(a) {
        ["mouseover", "mouseout"].map(function(b) {
            a.addEventListener(b, function(b) {
                a.classList.toggle("hover", "mouseover" == b.type)
            })
        });
        ["mousedown", "mouseup", "mouseout"].map(function(b) {
            a.addEventListener(b, function(b) {
                a.classList.toggle("active", "mousedown" == b.type)
            })
        });
        ["focus", "blur"].map(function(b) {
            a.addEventListener(b, function(b) {
                a.classList.toggle("focus", "focus" == b.type)
            })
        })
    }
    ;var xa = function() {
        this.yb = w.contentWindow
    };
    xa.prototype.postMessage = function(a, b) {
        this.yb.postMessage(a, b)
    }
    ;
    var w = null
        , ya = null
        , za = null
        , x = null
        , Aa = null
        , Ba = !1
        , Ca = []
        , Fa = function(a) {
        if (!w) {
            za = a;
            a = w = document.createElement("iframe");
            var b = Da() + "/gp/p/ui/payframe?origin=" + encodeURIComponent(window.location.origin);
            a.src = b;
            w.height = "0";
            w.width = "0";
            w.style.display = "none";
            w.style.visibility = "hidden";
            w.onload = function() {
                Ea()
            }
            ;
            document.body.appendChild(w);
            ya = new xa
        }
    }
        , Ga = function(a, b) {
        function c(a) {
            a.data.isReadyToPayResponse && (b(a),
                window.removeEventListener("message", c))
        }
        window.addEventListener("message", c);
        a = Object.assign({
            eventType: 6
        }, a);
        y(a)
    }
        , y = function(a) {
        Ba ? (a = Object.assign({
            buyFlowActivityMode: x,
            googleTransactionId: Aa
        }, a),
            ya.postMessage(a, Da())) : Ca.push(a)
    }
        , Ea = function() {
        Ba = !0;
        Ca.forEach(function(a) {
            y(a)
        })
    }
        , Da = function() {
        return "https://pay." + ("SANDBOX" === za ? "sandbox." : "") + "google.com"
    };
    var z = function(a) {
        this.h = a;
        this.H = null
    };
    z.prototype.R = function(a) {
        this.H = a
    }
    ;
    z.prototype.m = function(a) {
        var b = Ha(a);
        return new Promise(function(c) {
                b.canMakePayment().then(function(b) {
                    window.sessionStorage.setItem("google.payments.api.storage.isreadytopay.result", b.toString());
                    var d = {
                        result: b
                    };
                    2 <= a.apiVersion && a.existingPaymentMethodRequired && (d.paymentMethodPresent = b);
                    c(d)
                })["catch"](function() {
                    window.sessionStorage.getItem("google.payments.api.storage.isreadytopay.result") ? c({
                        result: "true" == window.sessionStorage.getItem("google.payments.api.storage.isreadytopay.result")
                    }) : c({
                        result: !1
                    })
                })
            }
        )
    }
    ;
    z.prototype.C = function(a) {
        Ha(a, this.h, a.transactionInfo.currencyCode, a.transactionInfo.totalPrice)
    }
    ;
    z.prototype.A = function(a) {
        Ia(this, a)
    }
    ;
    var Ha = function(a, b, c, d) {
        var e = {};
        a && (e = JSON.parse(JSON.stringify(a)));
        delete e.transactionInfo;
        e.apiVersion || (e.apiVersion = 1);
        b && "TEST" == b && (e.environment = b);
        return new PaymentRequest([{
            supportedMethods: ["https://google.com/pay"],
            data: e
        }],{
            total: {
                label: "Estimated Total Price",
                amount: {
                    currency: c || "USD",
                    value: d || "0"
                }
            }
        })
    }
        , Ia = function(a, b) {
        b = Ha(b, a.h, b.transactionInfo.currencyCode, b.transactionInfo.totalPrice);
        a.H(b.show().then(function(a) {
            a.complete("success");
            return a.details
        })["catch"](function(a) {
            a.statusCode = "CANCELED";
            throw a;
        }))
    };
    var Ja = function() {
        if (-1 != window.navigator.userAgent.indexOf("OPR/"))
            return !1;
        var a = window.navigator.userAgent.match(/Android/i)
            , b = window.navigator.userAgent.match(/Chrome\/([0-9]+)\./i);
        return null != a && "PaymentRequest"in window && "Google Inc." == window.navigator.vendor && null != b && 59 <= Number(b[1])
    }
        , La = function(a) {
        if (2 <= a.apiVersion) {
            var b = Ka(a);
            if (b && 1 == b.length && "CRYPTOGRAM_3DS" == b[0])
                return !0
        }
        return 1 == a.allowedPaymentMethods.length && "TOKENIZED_CARD" == a.allowedPaymentMethods[0]
    }
        , Ma = function(a, b) {
        return 2 <= a.apiVersion && (a = Ka(a)) && a.includes(b) ? !0 : !1
    }
        , Na = function() {
        return window.location.hostname.endsWith(".google.com") || void 0 === window.isSecureContext ? null : window.isSecureContext ? null : "Google Pay APIs should be called in secure context!"
    }
        , Oa = function(a) {
        if (a.environment && !Object.values(oa).includes(a.environment))
            throw Error("Parameter environment in PaymentOptions can optionally be set to PRODUCTION, otherwise it defaults to TEST.");
    }
        , Pa = function(a) {
        return Object.values(pa).includes(a)
    }
        , Qa = function(a) {
        if (!a)
            return "paymentDataRequest must be set!";
        if (a.swg)
            return (a = a.swg) ? a.skuId && a.publicationId ? null : "Both skuId and publicationId must be provided" : "Swg parameters must be provided";
        if (a.transactionInfo)
            if (a.transactionInfo.currencyCode) {
                if (!a.transactionInfo.totalPriceStatus || !Object.values(qa).includes(a.transactionInfo.totalPriceStatus))
                    return "totalPriceStatus in transactionInfo must be set to one of NOT_CURRENTLY_KNOWN, ESTIMATED or FINAL!";
                if ("NOT_CURRENTLY_KNOWN" !== a.transactionInfo.totalPriceStatus && !a.transactionInfo.totalPrice)
                    return "totalPrice in transactionInfo must be set when totalPriceStatus is ESTIMATED or FINAL!"
            } else
                return "currencyCode in transactionInfo must be set!";
        else
            return "transactionInfo must be set!";
        return null
    };
    function Ka(a) {
        return a.allowedPaymentMethods && 1 == a.allowedPaymentMethods.length && "CARD" == a.allowedPaymentMethods[0].type && a.allowedPaymentMethods[0].parameters ? a.allowedPaymentMethods[0].parameters.allowedAuthMethods : null
    }
    ;var A = function(a) {
        if (Error.captureStackTrace)
            Error.captureStackTrace(this, A);
        else {
            var b = Error().stack;
            b && (this.stack = b)
        }
        a && (this.message = String(a))
    };
    v(A, Error);
    A.prototype.name = "CustomError";
    var B = function(a, b) {
        a = a.split("%s");
        for (var c = "", d = a.length - 1, e = 0; e < d; e++)
            c += a[e] + (e < b.length ? b[e] : "%s");
        A.call(this, c + a[d])
    };
    v(B, A);
    B.prototype.name = "AssertionError";
    var Ra = function(a, b, c, d) {
        var e = "Assertion failed";
        if (c) {
            e += ": " + c;
            var f = d
        } else
            a && (e += ": " + a,
                f = b);
        throw new B("" + e,f || []);
    }
        , C = function(a, b, c) {
        a || Ra("", null, b, Array.prototype.slice.call(arguments, 2));
        return a
    }
        , Sa = function(a, b) {
        throw new B("Failure" + (a ? ": " + a : ""),Array.prototype.slice.call(arguments, 1));
    }
        , Ta = function(a, b, c) {
        r(a) || Ra("Expected object but got %s: %s.", [q(a), a], b, Array.prototype.slice.call(arguments, 2))
    };
    var D = function() {
        this.oa = "";
        this.$a = Ua
    };
    D.prototype.ua = !0;
    D.prototype.ta = function() {
        return this.oa
    }
    ;
    D.prototype.toString = function() {
        return "Const{" + this.oa + "}"
    }
    ;
    var E = function(a) {
        if (a instanceof D && a.constructor === D && a.$a === Ua)
            return a.oa;
        Sa("expected object of type Const, got '" + a + "'");
        return "type_error:Const"
    }
        , Ua = {}
        , F = function(a) {
        var b = new D;
        b.oa = a;
        return b
    };
    F("");
    var G = function() {
        this.ka = "";
        this.ab = Va
    };
    G.prototype.ua = !0;
    G.prototype.ta = function() {
        return this.ka
    }
    ;
    G.prototype.toString = function() {
        return "TrustedResourceUrl{" + this.ka + "}"
    }
    ;
    var Wa = function(a) {
        if (a instanceof G && a.constructor === G && a.ab === Va)
            return a.ka;
        Sa("expected object of type TrustedResourceUrl, got '" + a + "' of type " + q(a));
        return "type_error:TrustedResourceUrl"
    }
        , $a = function(a, b) {
        var c = E(a);
        if (!Xa.test(c))
            throw Error("Invalid TrustedResourceUrl format: " + c);
        a = c.replace(Ya, function(a, e) {
            if (!Object.prototype.hasOwnProperty.call(b, e))
                throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
            a = b[e];
            return a instanceof D ? E(a) : encodeURIComponent(String(a))
        });
        return Za(a)
    }
        , Ya = /%{(\w+)}/g
        , Xa = /^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank#/i
        , Va = {}
        , Za = function(a) {
        var b = new G;
        b.ka = a;
        return b
    };
    var ab = Array.prototype.indexOf ? function(a, b) {
            C(null != a.length);
            return Array.prototype.indexOf.call(a, b, void 0)
        }
        : function(a, b) {
            if (p(a))
                return p(b) && 1 == b.length ? a.indexOf(b, 0) : -1;
            for (var c = 0; c < a.length; c++)
                if (c in a && a[c] === b)
                    return c;
            return -1
        }
        , bb = Array.prototype.map ? function(a, b) {
            C(null != a.length);
            return Array.prototype.map.call(a, b, void 0)
        }
        : function(a, b) {
            for (var c = a.length, d = Array(c), e = p(a) ? a.split("") : a, f = 0; f < c; f++)
                f in e && (d[f] = b.call(void 0, e[f], f, a));
            return d
        }
    ;
    var cb = String.prototype.trim ? function(a) {
            return a.trim()
        }
        : function(a) {
            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]
        }
        , db = function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0
    }
        , eb = function(a) {
        return String(a).replace(/\-([a-z])/g, function(a, c) {
            return c.toUpperCase()
        })
    }
        , fb = function(a) {
        var b = p(void 0) ? "undefined".replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08") : "\\s";
        return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])","g"), function(a, b, e) {
            return b + e.toUpperCase()
        })
    };
    var I;
    a: {
        var gb = n.navigator;
        if (gb) {
            var hb = gb.userAgent;
            if (hb) {
                I = hb;
                break a
            }
        }
        I = ""
    }
    ;var ib = function(a, b) {
        for (var c in a)
            if (b.call(void 0, a[c], c, a))
                return !0;
        return !1
    }
        , jb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ")
        , kb = function(a, b) {
            for (var c, d, e = 1; e < arguments.length; e++) {
                d = arguments[e];
                for (c in d)
                    a[c] = d[c];
                for (var f = 0; f < jb.length; f++)
                    c = jb[f],
                    Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c])
            }
        };
    var lb = function(a) {
        lb[" "](a);
        return a
    };
    lb[" "] = la;
    var mb = -1 != I.indexOf("Opera"), J = -1 != I.indexOf("Trident") || -1 != I.indexOf("MSIE"), nb = -1 != I.indexOf("Edge"), ob = -1 != I.indexOf("Gecko") && !(-1 != I.toLowerCase().indexOf("webkit") && -1 == I.indexOf("Edge")) && !(-1 != I.indexOf("Trident") || -1 != I.indexOf("MSIE")) && -1 == I.indexOf("Edge"), pb = -1 != I.toLowerCase().indexOf("webkit") && -1 == I.indexOf("Edge"), qb = function() {
        var a = n.document;
        return a ? a.documentMode : void 0
    }, rb;
    a: {
        var sb = ""
            , tb = function() {
            var a = I;
            if (ob)
                return /rv:([^\);]+)(\)|;)/.exec(a);
            if (nb)
                return /Edge\/([\d\.]+)/.exec(a);
            if (J)
                return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
            if (pb)
                return /WebKit\/(\S+)/.exec(a);
            if (mb)
                return /(?:Version)[ \/]?(\S+)/.exec(a)
        }();
        tb && (sb = tb ? tb[1] : "");
        if (J) {
            var ub = qb();
            if (null != ub && ub > parseFloat(sb)) {
                rb = String(ub);
                break a
            }
        }
        rb = sb
    }
    var vb = rb, wb = {}, xb;
    var yb = n.document;
    xb = yb && J ? qb() || ("CSS1Compat" == yb.compatMode ? parseInt(vb, 10) : 5) : void 0;
    var K = function() {
        this.ia = "";
        this.Za = zb
    };
    K.prototype.ua = !0;
    K.prototype.ta = function() {
        return this.ia
    }
    ;
    K.prototype.toString = function() {
        return "SafeUrl{" + this.ia + "}"
    }
    ;
    var Ab = function(a) {
        if (a instanceof K && a.constructor === K && a.Za === zb)
            return a.ia;
        Sa("expected object of type SafeUrl, got '" + a + "' of type " + q(a));
        return "type_error:SafeUrl"
    }
        , Bb = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i
        , zb = {}
        , Cb = function(a) {
        var b = new K;
        b.ia = a;
        return b
    };
    Cb("about:blank");
    var Db = function(a, b, c, d) {
        a instanceof K || a instanceof K || (a = a.ua ? a.ta() : String(a),
        C(Bb.test(a)) || (a = "about:invalid#zClosurez"),
            a = Cb(a));
        return (b || window).open(Ab(a), c ? E(c) : "", d, void 0)
    };
    var Fb = function(a, b) {
        if (p("transition"))
            Eb(a, b, "transition");
        else
            for (var c in "transition")
                Eb(a, "transition"[c], c)
    }
        , Eb = function(a, b, c) {
        var d = Gb[c];
        if (!d) {
            var e = eb(c);
            d = e;
            void 0 === a.style[e] && (e = (pb ? "Webkit" : ob ? "Moz" : J ? "ms" : mb ? "O" : null) + fb(e),
            void 0 !== a.style[e] && (d = e));
            Gb[c] = d
        }
        (c = d) && (a.style[c] = b)
    }
        , Gb = {};
    var Hb = function(a, b) {
        "array" == q(b) || (b = [b]);
        C(0 < b.length, "At least one Css3Property should be specified.");
        b = bb(b, function(a) {
            if (p(a))
                return a;
            Ta(a, "Expected css3 property to be an object.");
            var b = a.pb + " " + a.duration + "s " + a.timing + " " + a.delay + "s";
            C(a.pb && "number" == typeof a.duration && a.timing && "number" == typeof a.delay, "Unexpected css3 property value: %s", b);
            return b
        });
        Fb(a, b.join(","))
    };
    var L = function() {
        this.da = this.da;
        this.ha = this.ha
    };
    L.prototype.da = !1;
    L.prototype.dispose = function() {
        this.da || (this.da = !0,
            this.N())
    }
    ;
    L.prototype.N = function() {
        if (this.ha)
            for (; this.ha.length; )
                this.ha.shift()()
    }
    ;
    var M = function(a, b) {
        this.type = a;
        this.currentTarget = this.target = b;
        this.defaultPrevented = this.F = !1;
        this.Wa = !0
    };
    M.prototype.stopPropagation = function() {
        this.F = !0
    }
    ;
    M.prototype.preventDefault = function() {
        this.defaultPrevented = !0;
        this.Wa = !1
    }
    ;
    var Ib = Object.freeze || function(a) {
            return a
        }
    ;
    var Jb;
    (Jb = !J) || (Jb = 9 <= Number(xb));
    var Kb = Jb, Lb;
    if (Lb = J) {
        var Mb;
        if (Object.prototype.hasOwnProperty.call(wb, "9"))
            Mb = wb["9"];
        else {
            for (var Nb = 0, Ob = cb(String(vb)).split("."), Pb = cb("9").split("."), Qb = Math.max(Ob.length, Pb.length), Rb = 0; 0 == Nb && Rb < Qb; Rb++) {
                var Sb = Ob[Rb] || ""
                    , Tb = Pb[Rb] || "";
                do {
                    var N = /(\d*)(\D*)(.*)/.exec(Sb) || ["", "", "", ""]
                        , O = /(\d*)(\D*)(.*)/.exec(Tb) || ["", "", "", ""];
                    if (0 == N[0].length && 0 == O[0].length)
                        break;
                    Nb = db(0 == N[1].length ? 0 : parseInt(N[1], 10), 0 == O[1].length ? 0 : parseInt(O[1], 10)) || db(0 == N[2].length, 0 == O[2].length) || db(N[2], O[2]);
                    Sb = N[3];
                    Tb = O[3]
                } while (0 == Nb)
            }
            Mb = wb["9"] = 0 <= Nb
        }
        Lb = !Mb
    }
    var Ub = Lb
        , Vb = function() {
        if (!n.addEventListener || !Object.defineProperty)
            return !1;
        var a = !1
            , b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0
            }
        });
        n.addEventListener("test", la, b);
        n.removeEventListener("test", la, b);
        return a
    }();
    var P = function(a, b) {
        M.call(this, a ? a.type : "");
        this.relatedTarget = this.currentTarget = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = this.offsetY = this.offsetX = 0;
        this.key = "";
        this.charCode = this.keyCode = 0;
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.O = null;
        if (a) {
            var c = this.type = a.type
                , d = a.changedTouches ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.currentTarget = b;
            if (b = a.relatedTarget) {
                if (ob) {
                    a: {
                        try {
                            lb(b.nodeName);
                            var e = !0;
                            break a
                        } catch (f) {}
                        e = !1
                    }
                    e || (b = null)
                }
            } else
                "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            null === d ? (this.offsetX = pb || void 0 !== a.offsetX ? a.offsetX : a.layerX,
                this.offsetY = pb || void 0 !== a.offsetY ? a.offsetY : a.layerY,
                this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX,
                this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY,
                this.screenX = a.screenX || 0,
                this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX,
                this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY,
                this.screenX = d.screenX || 0,
                this.screenY = d.screenY || 0);
            this.button = a.button;
            this.keyCode = a.keyCode || 0;
            this.key = a.key || "";
            this.charCode = a.charCode || ("keypress" == c ? a.keyCode : 0);
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = p(a.pointerType) ? a.pointerType : Wb[a.pointerType] || "";
            this.state = a.state;
            this.O = a;
            a.defaultPrevented && this.preventDefault()
        }
    };
    v(P, M);
    var Wb = Ib({
        2: "touch",
        3: "pen",
        4: "mouse"
    });
    P.prototype.stopPropagation = function() {
        P.pa.stopPropagation.call(this);
        this.O.stopPropagation ? this.O.stopPropagation() : this.O.cancelBubble = !0
    }
    ;
    P.prototype.preventDefault = function() {
        P.pa.preventDefault.call(this);
        var a = this.O;
        if (a.preventDefault)
            a.preventDefault();
        else if (a.returnValue = !1,
            Ub)
            try {
                if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode)
                    a.keyCode = -1
            } catch (b) {}
    }
    ;
    var Q = "closure_listenable_" + (1E6 * Math.random() | 0)
        , Xb = 0;
    var Yb = function(a, b, c, d, e) {
        this.listener = a;
        this.la = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ea = e;
        this.key = ++Xb;
        this.K = this.aa = !1
    }
        , Zb = function(a) {
        a.K = !0;
        a.listener = null;
        a.la = null;
        a.src = null;
        a.ea = null
    };
    var R = function(a) {
        this.src = a;
        this.c = {};
        this.X = 0
    };
    R.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.c[f];
        a || (a = this.c[f] = [],
            this.X++);
        var g = $b(a, b, d, e);
        -1 < g ? (b = a[g],
        c || (b.aa = !1)) : (b = new Yb(b,this.src,f,!!d,e),
            b.aa = c,
            a.push(b));
        return b
    }
    ;
    R.prototype.remove = function(a, b, c, d) {
        a = a.toString();
        if (!(a in this.c))
            return !1;
        var e = this.c[a];
        b = $b(e, b, c, d);
        return -1 < b ? (Zb(e[b]),
            C(null != e.length),
            Array.prototype.splice.call(e, b, 1),
        0 == e.length && (delete this.c[a],
            this.X--),
            !0) : !1
    }
    ;
    var ac = function(a, b) {
        var c = b.type;
        if (c in a.c) {
            var d = a.c[c], e = ab(d, b), f;
            if (f = 0 <= e)
                C(null != d.length),
                    Array.prototype.splice.call(d, e, 1);
            f && (Zb(b),
            0 == a.c[c].length && (delete a.c[c],
                a.X--))
        }
    };
    R.prototype.sa = function(a, b, c, d) {
        a = this.c[a.toString()];
        var e = -1;
        a && (e = $b(a, b, c, d));
        return -1 < e ? a[e] : null
    }
    ;
    R.prototype.hasListener = function(a, b) {
        var c = void 0 !== a
            , d = c ? a.toString() : ""
            , e = void 0 !== b;
        return ib(this.c, function(a) {
            for (var f = 0; f < a.length; ++f)
                if (!(c && a[f].type != d || e && a[f].capture != b))
                    return !0;
            return !1
        })
    }
    ;
    var $b = function(a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];
            if (!f.K && f.listener == b && f.capture == !!c && f.ea == d)
                return e
        }
        return -1
    };
    var bc = "closure_lm_" + (1E6 * Math.random() | 0)
        , dc = {}
        , ec = 0
        , gc = function(a, b, c, d, e) {
        if (d && d.once)
            fc(a, b, c, d, e);
        else if ("array" == q(b))
            for (var f = 0; f < b.length; f++)
                gc(a, b[f], c, d, e);
        else
            c = hc(c),
                a && a[Q] ? (d = r(d) ? !!d.capture : !!d,
                    ic(a),
                    a.l.add(String(b), c, !1, d, e)) : jc(a, b, c, !1, d, e)
    }
        , jc = function(a, b, c, d, e, f) {
        if (!b)
            throw Error("Invalid event type");
        var g = r(e) ? !!e.capture : !!e
            , h = kc(a);
        h || (a[bc] = h = new R(a));
        c = h.add(b, c, d, g, f);
        if (!c.la) {
            d = lc();
            c.la = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener)
                Vb || (e = g),
                void 0 === e && (e = !1),
                    a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent)
                a.attachEvent(mc(b.toString()), d);
            else if (a.addListener && a.removeListener)
                C("change" === b, "MediaQueryList only has a change event"),
                    a.addListener(d);
            else
                throw Error("addEventListener and attachEvent are unavailable.");
            ec++
        }
    }
        , lc = function() {
        var a = nc
            , b = Kb ? function(c) {
                return a.call(b.src, b.listener, c)
            }
            : function(c) {
                c = a.call(b.src, b.listener, c);
                if (!c)
                    return c
            }
        ;
        return b
    }
        , fc = function(a, b, c, d, e) {
        if ("array" == q(b))
            for (var f = 0; f < b.length; f++)
                fc(a, b[f], c, d, e);
        else
            c = hc(c),
                a && a[Q] ? a.l.add(String(b), c, !0, r(d) ? !!d.capture : !!d, e) : jc(a, b, c, !0, d, e)
    }
        , oc = function(a, b, c, d, e) {
        if ("array" == q(b))
            for (var f = 0; f < b.length; f++)
                oc(a, b[f], c, d, e);
        else
            d = r(d) ? !!d.capture : !!d,
                c = hc(c),
                a && a[Q] ? a.l.remove(String(b), c, d, e) : a && (a = kc(a)) && (b = a.sa(b, c, d, e)) && pc(b)
    }
        , pc = function(a) {
        if ("number" != typeof a && a && !a.K) {
            var b = a.src;
            if (b && b[Q])
                ac(b.l, a);
            else {
                var c = a.type
                    , d = a.la;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(mc(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                ec--;
                (c = kc(b)) ? (ac(c, a),
                0 == c.X && (c.src = null,
                    b[bc] = null)) : Zb(a)
            }
        }
    }
        , mc = function(a) {
        return a in dc ? dc[a] : dc[a] = "on" + a
    }
        , rc = function(a, b, c, d) {
        var e = !0;
        if (a = kc(a))
            if (b = a.c[b.toString()])
                for (b = b.concat(),
                         a = 0; a < b.length; a++) {
                    var f = b[a];
                    f && f.capture == c && !f.K && (f = qc(f, d),
                        e = e && !1 !== f)
                }
        return e
    }
        , qc = function(a, b) {
        var c = a.listener
            , d = a.ea || a.src;
        a.aa && pc(a);
        return c.call(d, b)
    }
        , nc = function(a, b) {
        if (a.K)
            return !0;
        if (!Kb) {
            if (!b)
                a: {
                    b = ["window", "event"];
                    for (var c = n, d = 0; d < b.length; d++)
                        if (c = c[b[d]],
                        null == c) {
                            b = null;
                            break a
                        }
                    b = c
                }
            d = b;
            b = new P(d,this);
            c = !0;
            if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;
                    if (0 == d.keyCode)
                        try {
                            d.keyCode = -1;
                            break a
                        } catch (g) {
                            e = !0
                        }
                    if (e || void 0 == d.returnValue)
                        d.returnValue = !0
                }
                d = [];
                for (e = b.currentTarget; e; e = e.parentNode)
                    d.push(e);
                a = a.type;
                for (e = d.length - 1; !b.F && 0 <= e; e--) {
                    b.currentTarget = d[e];
                    var f = rc(d[e], a, !0, b);
                    c = c && f
                }
                for (e = 0; !b.F && e < d.length; e++)
                    b.currentTarget = d[e],
                        f = rc(d[e], a, !1, b),
                        c = c && f
            }
            return c
        }
        return qc(a, new P(b,this))
    }
        , kc = function(a) {
        a = a[bc];
        return a instanceof R ? a : null
    }
        , sc = "__closure_events_fn_" + (1E9 * Math.random() >>> 0)
        , hc = function(a) {
        C(a, "Listener can not be null.");
        if ("function" == q(a))
            return a;
        C(a.handleEvent, "An object listener must have handleEvent method.");
        a[sc] || (a[sc] = function(b) {
                return a.handleEvent(b)
            }
        );
        return a[sc]
    };
    var S = function() {
        L.call(this);
        this.l = new R(this);
        this.bb = this;
        this.wa = null
    };
    v(S, L);
    S.prototype[Q] = !0;
    S.prototype.addEventListener = function(a, b, c, d) {
        gc(this, a, b, c, d)
    }
    ;
    S.prototype.removeEventListener = function(a, b, c, d) {
        oc(this, a, b, c, d)
    }
    ;
    S.prototype.dispatchEvent = function(a) {
        ic(this);
        var b = this.wa;
        if (b) {
            var c = [];
            for (var d = 1; b; b = b.wa)
                c.push(b),
                    C(1E3 > ++d, "infinite loop")
        }
        b = this.bb;
        d = a.type || a;
        if (p(a))
            a = new M(a,b);
        else if (a instanceof M)
            a.target = a.target || b;
        else {
            var e = a;
            a = new M(d,b);
            kb(a, e)
        }
        e = !0;
        if (c)
            for (var f = c.length - 1; !a.F && 0 <= f; f--) {
                var g = a.currentTarget = c[f];
                e = tc(g, d, !0, a) && e
            }
        a.F || (g = a.currentTarget = b,
            e = tc(g, d, !0, a) && e,
        a.F || (e = tc(g, d, !1, a) && e));
        if (c)
            for (f = 0; !a.F && f < c.length; f++)
                g = a.currentTarget = c[f],
                    e = tc(g, d, !1, a) && e;
        return e
    }
    ;
    S.prototype.N = function() {
        S.pa.N.call(this);
        if (this.l) {
            var a = this.l, b = 0, c;
            for (c in a.c) {
                for (var d = a.c[c], e = 0; e < d.length; e++)
                    ++b,
                        Zb(d[e]);
                delete a.c[c];
                a.X--
            }
        }
        this.wa = null
    }
    ;
    var tc = function(a, b, c, d) {
        b = a.l.c[String(b)];
        if (!b)
            return !0;
        b = b.concat();
        for (var e = !0, f = 0; f < b.length; ++f) {
            var g = b[f];
            if (g && !g.K && g.capture == c) {
                var h = g.listener
                    , H = g.ea || g.src;
                g.aa && ac(a.l, g);
                e = !1 !== h.call(H, d) && e
            }
        }
        return e && 0 != d.Wa
    };
    S.prototype.sa = function(a, b, c, d) {
        return this.l.sa(String(a), b, c, d)
    }
    ;
    S.prototype.hasListener = function(a, b) {
        return this.l.hasListener(void 0 !== a ? String(a) : void 0, b)
    }
    ;
    var ic = function(a) {
        C(a.l, "Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")
    };
    var uc = function(a, b) {
        S.call(this);
        this.ga = a || 1;
        this.W = b || n;
        this.Ia = t(this.xb, this);
        this.Na = u()
    };
    v(uc, S);
    k = uc.prototype;
    k.enabled = !1;
    k.o = null;
    k.setInterval = function(a) {
        this.ga = a;
        this.o && this.enabled ? (this.stop(),
            this.start()) : this.o && this.stop()
    }
    ;
    k.xb = function() {
        if (this.enabled) {
            var a = u() - this.Na;
            0 < a && a < .8 * this.ga ? this.o = this.W.setTimeout(this.Ia, this.ga - a) : (this.o && (this.W.clearTimeout(this.o),
                this.o = null),
                this.dispatchEvent("tick"),
            this.enabled && (this.stop(),
                this.start()))
        }
    }
    ;
    k.start = function() {
        this.enabled = !0;
        this.o || (this.o = this.W.setTimeout(this.Ia, this.ga),
            this.Na = u())
    }
    ;
    k.stop = function() {
        this.enabled = !1;
        this.o && (this.W.clearTimeout(this.o),
            this.o = null)
    }
    ;
    k.N = function() {
        uc.pa.N.call(this);
        this.stop();
        delete this.W
    }
    ;
    var vc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/
        , wc = function(a) {
        var b = a.match(vc);
        a = b[1];
        var c = b[3];
        b = b[4];
        var d = "";
        a && (d += a + ":");
        c && (d = d + "//" + c,
        b && (d += ":" + b));
        return d
    };
    /*

     Copyright 2017 The Web Activities Authors. All Rights Reserved.

     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at

          http://www.apache.org/licenses/LICENSE-2.0

     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS-IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
    */
    var xc = function(a, b, c, d, e) {
        this.code = a;
        this.data = "ok" == a ? b : null;
        this.mode = c;
        this.origin = d;
        this.Sa = e;
        this.ok = "ok" == a;
        this.error = "failed" == a ? Error(String(b) || "") : null
    }
        , T = function(a, b, c) {
        this.a = a;
        this.Ba = b;
        this.g = c;
        this.Ca = null;
        this.Da = !1;
        this.w = this.va = this.B = this.f = null;
        this.Ha = this.mb.bind(this)
    };
    T.prototype.connect = function(a) {
        if (this.B)
            throw Error("already connected");
        this.B = a;
        this.a.addEventListener("message", this.Ha)
    }
    ;
    T.prototype.disconnect = function() {
        if (this.B && (this.B = null,
        this.f && (U(this.f),
            this.f = null),
            this.a.removeEventListener("message", this.Ha),
            this.w)) {
            for (var a in this.w) {
                var b = this.w[a];
                b.port1 && U(b.port1);
                b.port2 && U(b.port2)
            }
            this.w = null
        }
    }
    ;
    T.prototype.isConnected = function() {
        return null != this.g
    }
    ;
    var yc = function(a) {
        a.B && !a.Ca && (a.Ca = "function" == typeof a.Ba ? a.Ba() : a.Ba);
        return a.Ca
    }
        , zc = function(a) {
        if (null == a.g)
            throw Error("not connected");
        return a.g
    }
        , Bc = function(a, b) {
        var c = null;
        a.Da && "function" == typeof a.a.MessageChannel && (c = new a.a.MessageChannel);
        c ? (V(a, "start", b, [c.port2]),
            Ac(a, c.port1)) : V(a, "start", b)
    }
        , V = function(a, b, c, d) {
        c = {
            sentinel: "__ACTIVITIES__",
            cmd: b,
            payload: c || null
        };
        if (a.f)
            a.f.postMessage(c, d || void 0);
        else {
            var e = yc(a);
            if (!e)
                throw Error("not connected");
            a = "connect" == b ? null != a.g ? a.g : "*" : zc(a);
            e.postMessage(c, a, d || void 0)
        }
    }
        , Cc = function(a, b) {
        a.w || (a.w = {});
        var c = a.w[b];
        if (!c) {
            var d;
            c = new Promise(function(a) {
                    d = a
                }
            );
            c = {
                port1: null,
                port2: null,
                Ua: d,
                Ob: c
            };
            a.w[b] = c
        }
        return c
    }
        , Ac = function(a, b) {
        a.f && U(a.f);
        a.f = b;
        a.f.onmessage = function(b) {
            var c = b.data
                , e = c && c.cmd;
            c = c && c.payload || null;
            e && a.I(e, c, b)
        }
    };
    T.prototype.mb = function(a) {
        var b = a.data;
        if (b && "__ACTIVITIES__" == b.sentinel) {
            var c = b.cmd;
            if (!this.f || "connect" == c || "start" == c) {
                var d = a.origin;
                b = b.payload || null;
                null == this.g && "start" == c && (this.g = d);
                null == this.g && a.source && yc(this) == a.source && (this.g = d);
                d == this.g && this.I(c, b, a)
            }
        }
    }
    ;
    T.prototype.I = function(a, b, c) {
        "connect" == a ? (this.f && (U(this.f),
            this.f = null),
            this.Da = b && b.acceptsChannel || !1,
            this.B(a, b)) : "start" == a ? ((c = c.ports && c.ports[0]) && Ac(this, c),
            this.B(a, b)) : "msg" == a ? null != this.va && null != b && this.va(b) : "cnget" == a ? (b = b.name || "",
            a = Cc(this, b),
        a.port1 || (c = new this.a.MessageChannel,
            a.port1 = c.port1,
            a.port2 = c.port2,
            a.Ua(a.port1)),
        a.port2 && (V(this, "cnset", {
            name: b
        }, [a.port2]),
            a.port2 = null)) : "cnset" == a ? (a = c.ports[0],
            b = Cc(this, b.name),
            b.port1 = a,
            b.Ua(a)) : this.B(a, b)
    }
    ;
    function U(a) {
        try {
            a.close()
        } catch (b) {}
    }
    function Dc(a) {
        var b = a.indexOf("#");
        return -1 == b ? a : a.substring(0, b)
    }
    function Ec(a) {
        return a ? (/^[?#]/.test(a) ? a.slice(1) : a).split("&").reduce(function(a, c) {
            var b = c.split("=");
            c = decodeURIComponent(b[0] || "");
            b = decodeURIComponent(b[1] || "");
            c && (a[c] = b);
            return a
        }, {}) : {}
    }
    function Fc(a) {
        var b = {
            requestId: a.qb,
            returnUrl: a.Va,
            args: a.cb
        };
        void 0 !== a.origin && (b.origin = a.origin);
        void 0 !== a.Sa && (b.originVerified = a.Sa);
        return JSON.stringify(b)
    }
    function Gc(a, b, c) {
        if (b.ok)
            c(b);
        else {
            var d;
            if (!(d = b.error)) {
                d = null;
                if ("function" == typeof a.DOMException) {
                    a = a.DOMException;
                    try {
                        d = new a("AbortError","AbortError")
                    } catch (e) {}
                }
                d || (d = Error("AbortError"),
                    d.name = "AbortError",
                    d.code = 20)
            }
            a = d;
            a.Lb = b;
            c(Promise.reject(a))
        }
    }
    var Hc = function(a, b, c) {
        var d = this;
        this.fa = a;
        this.qa = b;
        this.Z = c || null;
        this.a = this.fa.ownerDocument.defaultView;
        this.g = wc(Wa(b));
        this.Ja = null;
        this.hb = new Promise(function(a) {
                d.Ja = a
            }
        );
        this.ma = null;
        new Promise(function(a) {
                d.ma = a
            }
        );
        this.j = null;
        this.na = new Promise(function(a) {
                d.j = a
            }
        );
        this.Ta = this.Qa = null;
        this.b = new T(this.a,function() {
                return d.fa.contentWindow
            }
            ,this.g)
    };
    k = Hc.prototype;
    k.connect = function() {
        if (!this.a.document.documentElement.contains(this.fa))
            throw Error("iframe must be in DOM");
        this.b.connect(this.I.bind(this));
        var a = this.fa
            , b = this.qa;
        var c = (c = a && a.ownerDocument) && (c.defaultView || c.parentWindow) || n;
        if ("undefined" != typeof c.HTMLIFrameElement && "undefined" != typeof c.Location && "undefined" != typeof c.Element) {
            c = a && (a instanceof c.HTMLIFrameElement || !(a instanceof c.Location || a instanceof c.Element));
            var d = r(a) ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : void 0 === a ? "undefined" : null === a ? "null" : typeof a;
            C(c, "Argument is not a %s (or a non-Element, non-Location mock); got: %s", "HTMLIFrameElement", d)
        }
        a.src = Wa(b);
        return this.hb
    }
    ;
    k.disconnect = function() {
        this.b.disconnect()
    }
    ;
    k.Y = function() {
        return this.na
    }
    ;
    k.message = function(a) {
        V(this.b, "msg", a)
    }
    ;
    k.onMessage = function(a) {
        this.b.va = a
    }
    ;
    k.I = function(a, b) {
        "connect" == a ? (Bc(this.b, this.Z),
            this.Ja()) : "result" == a ? this.j && (a = b.code,
            b = new xc(a,"failed" == a ? Error(b.data || "") : b.data,"iframe",zc(this.b),!0),
            Gc(this.a, b, this.j),
            this.j = null,
            V(this.b, "close"),
            this.disconnect()) : "ready" == a ? this.ma && (this.ma(),
            this.ma = null) : "resize" == a && (this.Ta = b.height,
        this.Qa && this.Qa(this.Ta))
    }
    ;
    var W = function(a, b, c, d, e, f) {
        var g = this
            , h = d && E(d);
        if (!h || "_blank" != h && "_top" != h && "_" == h[0])
            throw Error('The only allowed targets are "_blank", "_top" and name targets');
        this.a = a;
        this.rb = b;
        this.qa = c;
        this.nb = d;
        this.Z = e || null;
        this.u = f || null;
        this.j = null;
        this.na = new Promise(function(a) {
                g.j = a
            }
        );
        this.b = this.s = this.D = null
    };
    W.prototype.open = function() {
        return Ic(this)
    }
    ;
    W.prototype.disconnect = function() {
        this.s && (this.s.stop(),
            this.s = null);
        this.b && (this.b.disconnect(),
            this.b = null);
        if (this.D) {
            try {
                this.D.close()
            } catch (a) {}
            this.D = null
        }
        this.j = null
    }
    ;
    W.prototype.Y = function() {
        return this.na
    }
    ;
    var Ic = function(a) {
        var b = Jc(a)
            , c = a.qa;
        if (!a.u || !a.u.Pb) {
            var d = Fc({
                qb: a.rb,
                Va: a.u && a.u.Va || Dc(a.a.location.href),
                cb: a.Z
            });
            c = c + (-1 == c.indexOf("#") ? "#" : "&") + encodeURIComponent("__WA__") + "=" + encodeURIComponent(d)
        }
        d = a.nb;
        if ("_top" != E(d)) {
            var e = a.a.navigator;
            /Trident|MSIE|IEMobile/i.test(e && e.userAgent) && (d = F("_top"))
        }
        try {
            var f = Db(c, a.a, d, b)
        } catch (g) {}
        if (!f && "_top" != E(d)) {
            d = F("_top");
            try {
                f = Db(c, a.a, d)
            } catch (g) {}
        }
        f ? (a.D = f,
        "_top" != E(d) && Kc(a)) : Lc(a, Error("failed to open window"));
        return a.na["catch"](function() {})
    }
        , Jc = function(a) {
        var b = a.a.screen
            , c = b.availWidth || b.width
            , d = b.availHeight || b.height
            , e = a.a == a.a.top
            , f = a.a.navigator;
        f = /Edge/i.test(f && f.userAgent);
        c = Math.max(c - (e && a.a.outerWidth > a.a.innerWidth ? Math.min(100, a.a.outerWidth - a.a.innerWidth) : f ? 100 : 0), .5 * c);
        var g = Math.max(d - (e && a.a.outerHeight > a.a.innerHeight ? Math.min(100, a.a.outerHeight - a.a.innerHeight) : f ? 100 : 0), .5 * d);
        d = Math.floor(Math.min(600, .9 * c));
        e = Math.floor(Math.min(600, .9 * g));
        a.u && (a.u.width && (d = Math.min(a.u.width, c)),
        a.u.height && (e = Math.min(a.u.height, g)));
        a = Math.floor((b.width - d) / 2);
        b = Math.floor((b.height - e) / 2);
        c = {
            height: e,
            width: d,
            resizable: "yes",
            scrollbars: "yes"
        };
        f || (c.left = a,
            c.top = b);
        f = "";
        for (var h in c)
            f && (f += ","),
                f += h + "=" + c[h];
        return f
    }
        , Kc = function(a) {
        a.s = new uc(500);
        a.s.addEventListener("tick", function() {
            Mc(a, !0)
        });
        a.s.start();
        a.b = new T(a.a,a.D,null);
        a.b.connect(a.I.bind(a))
    }
        , Mc = function(a, b) {
        if (!a.D || a.D.closed)
            a.s && (a.s.stop(),
                a.s = null),
                a.a.setTimeout(function() {
                    try {
                        a.L("canceled", null)
                    } catch (c) {
                        Lc(a, c)
                    }
                }, b ? 3E3 : 0)
    }
        , Lc = function(a, b) {
        a.j && a.j(Promise.reject(b));
        a.disconnect()
    };
    W.prototype.L = function(a, b) {
        if (this.j) {
            var c = this.b.isConnected();
            a = new xc(a,b,"popup",c ? zc(this.b) : wc(this.qa),c);
            Gc(this.a, a, this.j);
            this.j = null
        }
        this.b && V(this.b, "close");
        this.disconnect()
    }
    ;
    W.prototype.I = function(a, b) {
        var c = this;
        "connect" == a ? Bc(this.b, this.Z) : "result" == a ? (a = b.code,
            this.L(a, "failed" == a ? Error(b.data || "") : b.data)) : "check" == a && this.a.setTimeout(function() {
            return Mc(c)
        }, 200)
    }
    ;
    var Nc = function(a, b, c, d, e) {
        this.a = a;
        this.gb = b;
        this.ib = c;
        this.g = d;
        this.wb = e
    };
    Nc.prototype.Y = function() {
        var a = this
            , b = new xc(this.gb,this.ib,"redirect",this.g,this.wb);
        return new Promise(function(c) {
                Gc(a.a, b, c)
            }
        )
    }
    ;
    var Oc = function() {
        var a = window;
        this.version = "1.12";
        this.a = a;
        this.La = a.location.hash;
        this.ya = {};
        this.za = {}
    }
        , Pc = function(a, b, c) {
        var d = new Hc(a,b,c);
        return d.connect().then(function() {
            return d
        })
    };
    Oc.prototype.open = function(a, b, c, d, e) {
        var f = this
            , g = new W(this.a,a,b,c,d,e);
        g.open().then(function() {
            Qc(f, a, g)
        });
        return {
            Qb: g.D
        }
    }
    ;
    Oc.prototype.R = function(a, b) {
        var c = this.ya[a];
        c || (c = [],
            this.ya[a] = c);
        c.push(b);
        c = this.za[a];
        if (!c && this.La) {
            c = this.a;
            var d = Ec(this.La).__WA_RES__;
            if (d)
                if ((d = JSON.parse(decodeURIComponent(d))) && d.requestId == a) {
                    var e = c.location.hash;
                    if (e) {
                        var f = encodeURIComponent("__WA_RES__") + "="
                            , g = -1;
                        do
                            if (g = e.indexOf(f, g),
                            -1 != g) {
                                var h = 0 < g ? e.substring(g - 1, g) : "";
                                "" == h || "?" == h || "#" == h || "&" == h ? (h = e.indexOf("&", g + 1),
                                -1 == h && (h = e.length),
                                    e = e.substring(0, g) + e.substring(h + 1)) : g++
                            }
                        while (-1 != g && g < e.length)
                    }
                    e = e || "";
                    if (e != c.location.hash && c.history && c.history.replaceState)
                        try {
                            c.history.replaceState(c.history.state, "", e)
                        } catch (H) {}
                    e = d.code;
                    f = d.data;
                    d = d.origin;
                    g = c.document.referrer && wc(c.document.referrer);
                    c = new Nc(c,e,f,d,d == g)
                } else
                    c = null;
            else
                c = null;
            c && (this.za[a] = c)
        }
        (a = c) && Rc(a, b)
    }
    ;
    var Rc = function(a, b) {
        Promise.resolve().then(function() {
            b(a)
        })
    }
        , Qc = function(a, b, c) {
        var d = a.ya[b];
        d && d.forEach(function(a) {
            Rc(c, a)
        });
        a.za[b] = c
    };
    var X = function(a, b, c) {
        this.h = a;
        this.Ya = c || !1;
        this.Ea = new Oc;
        this.T = this.H = null;
        this.Aa = !1;
        this.Ka = this.f = null;
        this.P = b;
        this.U = null;
        Aa = this.P;
        ua("\n.dialog {\n    animation: none 0s ease 0s 1 normal none running;\n    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255);\n    background-blend-mode: normal;\n    border: 0px none rgb(51, 51, 51);\n    border-radius: 8px 8px 0px 0px;\n    border-collapse: separate;\n    bottom: 0px;\n    box-shadow: rgb(128, 128, 128) 0px 3px 0px 0px, rgb(128, 128, 128) 0px 0px 22px 0px;\n    box-sizing: border-box;\n    left: -240px;\n    letter-spacing: normal;\n    max-height: 100%;\n    overflow: visible;\n    position: fixed;\n    width: 100%;\n    z-index: 2147483647;\n    -webkit-appearance: none;\n    left: 0px;\n}\n@media (min-width: 480px) {\n  .dialog{\n    width: 480px !important;\n    left: -240px !important;\n    margin-left: calc(100vw - 100vw / 2) !important;\n  }\n}\n.dialogContainer {\n  background-color: rgba(0,0,0,0.85);\n  bottom: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n}\n.iframeContainer {\n  -webkit-overflow-scrolling: touch;\n}\n")
    };
    X.prototype.R = function(a) {
        var b = this;
        this.H || (this.H = a,
            this.Ea.R("request1", function(c) {
                a(c.Y().then(function(a) {
                    a = a.data;
                    return a.redirectEncryptedCallbackData ? (x = 3,
                        fetch(Sc(b) + "/apis/buyflow/process", {
                            method: "post",
                            credentials: "include",
                            mode: "cors",
                            body: a.redirectEncryptedCallbackData
                        }).then(function(a) {
                            return a.json()
                        })) : a
                }, function(a) {
                    var b = a.message;
                    a = a.message;
                    try {
                        a = JSON.parse(b.substring(7))
                    } catch (f) {}
                    a.statusCode && -1 == ["DEVELOPER_ERROR", "MERCHANT_ACCOUNT_ERROR"].indexOf(a.statusCode) && (a = {
                        statusCode: "CANCELED"
                    });
                    "AbortError" == a && (a = {
                        statusCode: "CANCELED"
                    });
                    console.log("Google Pay request failed, error:\n" + JSON.stringify(a));
                    return Promise.reject(a)
                }))
            }))
    }
    ;
    X.prototype.m = function(a) {
        var b = this;
        return new Promise(function(c) {
                if (La(a))
                    c({
                        result: !1
                    });
                else {
                    var d = window.navigator.userAgent;
                    if (0 < d.indexOf("GSA/") && 0 < d.indexOf("Safari"))
                        c({
                            result: !1
                        });
                    else if (0 < d.indexOf("FxiOS"))
                        c({
                            result: !1
                        });
                    else {
                        var e = 0 < d.indexOf("Chrome") || 0 < d.indexOf("Firefox") || 0 < d.indexOf("Safari");
                        e && 2 <= a.apiVersion ? (a.environment = b.h,
                            Ga(a, function(b) {
                                var d = {
                                    result: e
                                };
                                a.existingPaymentMethodRequired && (d.paymentMethodPresent = "READY_TO_PAY" == b.data.isReadyToPayResponse);
                                c(d)
                            })) : c({
                            result: e
                        })
                    }
                }
            }
        )
    }
    ;
    X.prototype.C = function(a) {
        if (this.Ya) {
            Tc(this, a);
            var b = Uc(this)
                , c = Vc(this, b.container, b.iframe, a);
            this.T = {
                container: b.container,
                iframe: b.iframe,
                request: a,
                dataPromise: c
            }
        }
    }
    ;
    X.prototype.A = function(a) {
        var b = this;
        Tc(this, a);
        a.swg || a.apiVersion || (a.apiVersion = 1);
        a.environment = this.h;
        if (this.Ya) {
            x = 1;
            if (this.T) {
                var c = this.T;
                a = this.T.dataPromise;
                this.T = null
            } else
                c = Uc(this),
                    a = Vc(this, c.container, c.iframe, a);
            Wc(this, c.container, c.iframe);
            c = new Promise(function(a) {
                    b.Ka = a
                }
            );
            this.H(Promise.race([a, c]))
        } else
            x = a.forceRedirect ? 3 : 2,
                this.Ea.open("request1", Sc(this) + "/ui/pay", a.forceRedirect ? F("_top") : F("gp-js-popup"), a, {
                    width: 600,
                    height: 600
                })
    }
    ;
    var Tc = function(a, b) {
        a = {
            startTimeMs: u(),
            googleTransactionId: a.P
        };
        b.i = b.i ? Object.assign(a, b.i) : a
    }
        , Sc = function(a) {
        return ("SANDBOX" == a.h ? "https://pay.sandbox.google.com" : "https://pay.google.com") + "/gp/p"
    }
        , Xc = function(a) {
        var b = window.location.origin
            , c = F("https://pay.google.com/gp/p/ui/pay?origin=%{origin}");
        "SANDBOX" == a && (c = F("https://pay.sandbox.google.com/gp/p/ui/pay?origin=%{origin}"));
        return $a(c, {
            origin: b
        })
    }
        , Zc = function(a, b) {
        Yc(b, "all 300ms ease 0s");
        b.height = "0px";
        setTimeout(function() {
            a.parentNode.removeChild(a)
        }, 300)
    }
        , Uc = function(a) {
        var b = document.createElement("div");
        b.classList.add("dialogContainer");
        var c = document.createElement("div");
        c.classList.add("iframeContainer");
        var d = document.createElement("iframe");
        d.classList.add("dialog");
        d.setAttribute("frameborder", "0");
        d.setAttribute("scrolling", "no");
        c.appendChild(d);
        b.appendChild(c);
        document.body.appendChild(b);
        b = {
            container: b,
            iframe: d
        };
        c = b.iframe;
        d = b.container;
        d.addEventListener("click", t(a.jb, a, b));
        d.style.display = "none";
        c.style.display = "none";
        c.height = "0px";
        Yc(c, "all 300ms ease 0s");
        a.Aa = !1;
        return b
    };
    X.prototype.jb = function(a) {
        this.Ka(Promise.reject({
            errorCode: "CANCELED"
        }));
        Zc(a.container, a.iframe);
        this.f.disconnect()
    }
    ;
    var Wc = function(a, b, c) {
        b.style.display = "block";
        c.style.display = "block";
        setTimeout(function() {
            c.height = "260px";
            setTimeout(function() {
                a.Aa = !0;
                a.U && (Yc(c, a.U.transition),
                    c.height = a.U.height,
                    a.U = null)
            }, 300)
        }, 1)
    }
        , Yc = function(a, b) {
        Hb(a, b);
        a.style.setProperty("-webkit-transition", b)
    }
        , Vc = function(a, b, c, d) {
        d.swg || (d.apiVersion || (d.apiVersion = 1),
            d.allowedPaymentMethods = ["CARD"]);
        d.environment = a.h;
        var e = Xc(a.h);
        return Pc(c, e, d).then(function(b) {
            a.f = b;
            b.onMessage(function(b) {
                "resize" === b.type && a.Aa ? (Yc(c, b.transition),
                    c.height = b.height) : a.U = {
                    height: b.height,
                    transition: b.transition
                }
            });
            return b.Y()
        }).then(function(a) {
            Zc(b, c);
            return a.data
        }, function(a) {
            Zc(b, c);
            return Promise.reject(a)
        })
    };
    /*

    Math.uuid.js (v1.4)
    http://www.broofa.com
    mailto:robert@broofa.com
    Copyright (c) 2010 Robert Kieffer
    Dual licensed under the MIT and GPL licenses.
    */
    var $c = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
    var ad = "actions.google.com amp-actions.sandbox.google.com amp-actions-staging.sandbox.google.com amp-actions-autopush.sandbox.google.com payments.developers.google.com payments.google.com".split(" ")
        , Y = function(a, b, c) {
        this.Pa = b;
        Oa(a);
        this.Oa = null;
        this.h = a.environment || "TEST";
        this.P = bd(this.h);
        this.G = new X(this.h,this.P,c);
        this.M = Ja() && !c ? new z(this.h) : this.G;
        this.G.R(this.Ra.bind(this));
        this.M.R(this.Ra.bind(this));
        Fa(this.h);
        Aa = this.P;
        window.addEventListener("message", function(a) {
            -1 != ad.indexOf(window.location.hostname) && "logPaymentData" === a.data.name && y(a.data.data)
        })
    };
    Y.prototype.m = function(a) {
        var b = Na() || (a ? a.apiVersion || a.allowedPaymentMethods && Array.isArray(a.allowedPaymentMethods) && 0 != a.allowedPaymentMethods.length && a.allowedPaymentMethods.every(Pa) ? null : "allowedPaymentMethods must be set to an array containing 'CARD' and/or 'TOKENIZED_CARD'!" : "isReadyToPayRequest must be set!");
        if (b)
            return new Promise(function(a, c) {
                    cd("isReadyToPay", b);
                    y({
                        eventType: 0,
                        error: 2
                    });
                    c({
                        statusCode: "DEVELOPER_ERROR",
                        statusMessage: b
                    })
                }
            );
        var c = u();
        a = dd(this, a);
        a.then(function(a) {
            y({
                eventType: 0,
                clientLatencyStartMs: c,
                isReadyToPayApiResult: a.result
            });
            return a
        });
        return a
    }
    ;
    Y.prototype.isReadyToPay = Y.prototype.m;
    var dd = function(a, b) {
        if (Ja()) {
            if (2 <= b.apiVersion)
                return ed(a, b);
            var c = a.G.m(b);
            a = a.M.m(b);
            return La(b) ? a : a.then(function() {
                return c
            })
        }
        return a.G.m(b)
    }
        , ed = function(a, b) {
        var c = Promise.resolve({
            result: !1
        });
        b.existingPaymentMethodRequired && (c = Promise.resolve({
            result: !1,
            paymentMethodPresent: !1
        }));
        var d = c;
        Ma(b, "CRYPTOGRAM_3DS") && (d = JSON.parse(JSON.stringify(b)),
            d.allowedPaymentMethods[0].parameters.Mb = ["CRYPTOGRAM_3DS"],
            d = a.M.m(d));
        var e = c;
        Ma(b, "PAN_ONLY") && (e = a.G.m(b));
        return d.then(function(a) {
            return 1 == (a && a.result) ? a : e
        })
    };
    Y.prototype.C = function(a) {
        var b = Na() || Qa(a);
        b ? cd("prefetchPaymentData", b) : Ja() ? this.M.C(a) : this.G.C(a)
    }
    ;
    Y.prototype.prefetchPaymentData = Y.prototype.C;
    Y.prototype.A = function(a) {
        y({
            eventType: 5
        });
        var b = Na() || Qa(a);
        if (b)
            this.Pa(new Promise(function(a, c) {
                    y({
                        eventType: 1,
                        error: 2
                    });
                    cd("loadPaymentData", b);
                    c({
                        statusCode: "DEVELOPER_ERROR",
                        statusMessage: b
                    })
                }
            ));
        else {
            var c = "false" === window.sessionStorage.getItem("google.payments.api.storage.isreadytopay.result");
            this.Oa = u();
            a.swg || c ? this.G.A(a) : this.M.A(a)
        }
    }
    ;
    Y.prototype.loadPaymentData = Y.prototype.A;
    var cd = function(a, b) {
        console.error("DEVELOPER_ERROR in " + a + " : " + b)
    };
    Y.prototype.ca = function(a) {
        a = void 0 === a ? {} : a;
        a = void 0 === a ? {} : a;
        if (!va) {
            ua("\n.gpay-button {\n  background-origin: content-box;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: 0px;\n  border-radius: 4px;\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 1px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n  cursor: pointer;\n  height: 40px;\n  min-height: 40px;\n  outline: 0px;\n  padding: 11px 24px;\n}\n\n.black {\n  background-color: #000;\n  box-shadow: none;\n  padding: 12px 24px 10px;\n}\n\n.white {\n  background-color: #fff;\n}\n\n.short {\n  min-width: 90px;\n  width: 160px;\n}\n\n.black.short {\n  background-image: url(https://www.gstatic.com/instantbuy/svg/dark_gpay.svg);\n}\n\n.white.short {\n  background-image: url(https://www.gstatic.com/instantbuy/svg/light_gpay.svg);\n}\n\n.black.active {\n  background-color: #5f6368;\n}\n\n.black.hover {\n  background-color: #3c4043;\n}\n\n.white.active {\n  background-color: #fff;\n}\n\n.white.focus {\n  box-shadow: #e8e8e8 0 1px 1px 0, #e8e8e8 0 1px 3px;\n}\n\n.white.hover {\n  background-color: #f8f8f8;\n}\n");
            var b = navigator.language || navigator.Rb || "en";
            "en" != b && (b = b.substring(0, 2),
            ta[b] || (b = "en"));
            ua("\n    .long {\n      min-width: " + ta[b] + "px;\n      width: 240px;\n    }\n\n    .white.long {\n      background-image: url(https://www.gstatic.com/instantbuy/svg/light/" + b + ".svg);\n    }\n\n    .black.long {\n      background-image: url(https://www.gstatic.com/instantbuy/svg/dark/" + b + ".svg);\n    }");
            va = !0
        }
        b = document.createElement("button");
        Object.values(ra).includes(a.buttonType) || (a.buttonType = "long");
        Object.values(sa).includes(a.buttonColor) || (a.buttonColor = "default");
        "default" == a.buttonColor && (a.buttonColor = "black");
        a: {
            if ("long" == a.buttonType) {
                if ("white" == a.buttonColor) {
                    var c = "white long";
                    break a
                }
            } else if ("short" == a.buttonType) {
                c = "white" == a.buttonColor ? "white short" : "black short";
                break a
            }
            c = "black long"
        }
        b.setAttribute("class", "gpay-button " + c);
        wa(b);
        if (a.onClick)
            b.addEventListener("click", a.onClick);
        else
            throw Error("Parameter 'onClick' must be set.");
        a = document.createElement("div");
        a.appendChild(b);
        y({
            eventType: 2
        });
        return a
    }
    ;
    Y.prototype.createButton = Y.prototype.ca;
    Y.prototype.Ra = function(a) {
        var b = this;
        a.then(function() {
            y({
                eventType: 1,
                clientLatencyStartMs: b.Oa
            })
        })["catch"](function(a) {
            a.errorCode ? y({
                eventType: 1,
                error: a.errorCode
            }) : y({
                eventType: 1,
                error: 6
            })
        });
        this.Pa(a)
    }
    ;
    var bd = function(a) {
        for (var b = Array(36), c = 0, d, e = 0; 36 > e; e++)
            8 == e || 13 == e || 18 == e || 23 == e ? b[e] = "-" : 14 == e ? b[e] = "4" : (2 >= c && (c = 33554432 + 16777216 * Math.random() | 0),
                d = c & 15,
                c >>= 4,
                b[e] = $c[19 == e ? d & 3 | 8 : d]);
        return b.join("") + "." + a
    };
    ja("google.payments.api.PaymentsAsyncClient", Y);
    var Z = function(a, b) {
        a = void 0 === a ? {} : a;
        this.$ = new Y(a,this.ob.bind(this),b);
        this.S = null
    };
    Z.prototype.ob = function(a) {
        this.S(a)
    }
    ;
    Z.prototype.m = function(a) {
        return this.$.m(a)
    }
    ;
    Z.prototype.isReadyToPay = Z.prototype.m;
    Z.prototype.C = function(a) {
        this.$.C(a)
    }
    ;
    Z.prototype.prefetchPaymentData = Z.prototype.C;
    Z.prototype.A = function(a) {
        var b = this;
        return (new Promise(function(c) {
                if (b.S)
                    throw Error("This method can only be called one at a time.");
                b.S = c;
                b.$.A(a)
            }
        )).then(function(a) {
            b.S = null;
            return a
        }, function(a) {
            b.S = null;
            throw a;
        })
    }
    ;
    Z.prototype.loadPaymentData = Z.prototype.A;
    Z.prototype.ca = function(a) {
        a = void 0 === a ? {} : a;
        return this.$.ca(a)
    }
    ;
    Z.prototype.createButton = Z.prototype.ca;
    ja("google.payments.api.PaymentsClient", Z);

})();